import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import "./theme/app.css";
import { applyTheme } from "./theme/tokens";
import { useTheme } from "./shared/stores/theme";
import App from "./App";
import { ErrorBoundary } from "./shared/components/ErrorBoundary";

// Apply theme from persisted store (rehydrate fires applyTheme too — this handles
// the very first paint before rehydrate runs).
applyTheme(useTheme.getState());

const qc = new QueryClient({
  defaultOptions: { queries: { retry: 1, staleTime: 30_000, refetchOnWindowFocus: false } },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={qc}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </QueryClientProvider>
    </ErrorBoundary>
  </React.StrictMode>,
);
